export const flatMap = <I = any, O = any>(array: Array<I>, fn: (obj: I) => O): O =>
  array.map(fn).reduce((xs: any, ys: any) => [...xs, ...ys], []);
